export default {
	data(){
		return {
			warningClass: function (items) { return items['info_afiliacion/nota_delete']!==null ? true : false},
			tableGBoptions: { 
				modals: [
					{
						modal: "Editar",
						icon: "pencil",
						title: "Editar Ficha Afiliado",
						variant: 'primary',
						showFtn: function (value) {
							if(value['info_ingresos/anulado']===1 && value['info_afiliacion/nota_delete']===null && value['info_afiliacion/id_list_novedad']===1){ return true} return false;
						},
					},
					{
						modal: "Registrar",
						icon: "credit-card",
						title: "Registro de la afiliación",
						showFtn: function (value) {
							if(value['info_ingresos/anulado']===1 && value['info_afiliacion/nota_delete']===null && value['info_afiliacion/id_list_novedad']===1){ return true} return false;
						},
					},
					{
						modal: "Anular",
						icon: "x-circle",
						title: "Anular Afiliación",
						variant: 'danger',
						showFtn: function (value) {
							if(value['info_afiliacion/id_list_novedad']===1 && value['info_afiliacion/nota_delete']===null){ return true} return false;
						},						
					},
				]
			},

			tableGBSearch: ['datos_afiliado/documento','datos_afiliado/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento', sort: null, sortTable: 'datos_afiliado/documento'},
					tbody: { td: ['datos_afiliado/documento',]}
				},
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Asesor', },
					tbody: { td: ['datos_asesor/name'],ftn: function(value) { let name=value.split(' '); if(name.length>1){ return name[0]+' '+name[1]}else{return name[0]}}}
				},
				{
					thead: { th: 'Fecha', },
					tbody: { td: ['info_afiliacion/fecha'],}
				},
				{
					thead: { th: 'Servicios', },
					tbody: { table: {
						value: false,
							tabla: 'servicios/servicios',
							search: ['name'],						
							items: [
								{
									thead: { th: 'Servicio'},
									tbody: {td: ['name']},
								},	
								{
									thead: { th: 'Entidad'},
									tbody: {td: ['id_list']},
								},
								{
									thead: { th: 'Afiliación'},
									tbody: {td: ['afiliacion']},
								},							
							]
						}
					}
				},
				{
					thead: { th: 'Registro'},
					tbody: {td: ['info_ingresos/id'], link: '/api/pdf/registro',show: {td: 'info_ingresos/anulado', compare: 0, else: 'Anulado'}},
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
				},
			],			
		
		}
	},
}